import React, { useState } from "react";

import ContentHeader from "components/Layout/ContentHeader";
import Badge from "components/UI/Badge";
import Button from "components/UI/Button";
import { Input, Select } from "components/UI/Input";
import Modal from "components/UI/Modal";
import Table, { Column } from "components/UI/Table";
import "pages/AdminPage.scss";

interface Admin {
  id: string;
  name: string;
  email: string;
  role: "super_admin" | "admin" | "cs";
  status: "active" | "inactive";
  lastLogin: string;
  createdAt: string;
}

const ROLE_LABEL: Record<string, string> = {
  super_admin: "슈퍼 어드민",
  admin: "어드민",
  cs: "CS 담당",
};
const ROLE_BADGE: Record<string, "rejected" | "info" | "pending"> = { super_admin: "rejected", admin: "info", cs: "pending" };

const MOCK: Admin[] = [
  {
    id: "1",
    name: "박관리",
    email: "admin1@buccl.com",
    role: "super_admin",
    status: "active",
    lastLogin: "2024-03-05 09:00",
    createdAt: "2023-01-01",
  },
  {
    id: "2",
    name: "이담당",
    email: "admin2@buccl.com",
    role: "admin",
    status: "active",
    lastLogin: "2024-03-04 17:30",
    createdAt: "2023-06-15",
  },
  {
    id: "3",
    name: "김운영",
    email: "admin3@buccl.com",
    role: "admin",
    status: "active",
    lastLogin: "2024-03-05 11:20",
    createdAt: "2023-08-01",
  },
  {
    id: "4",
    name: "최고객",
    email: "cs1@buccl.com",
    role: "cs",
    status: "active",
    lastLogin: "2024-03-05 10:15",
    createdAt: "2023-09-10",
  },
  {
    id: "5",
    name: "정서비스",
    email: "cs2@buccl.com",
    role: "cs",
    status: "inactive",
    lastLogin: "2024-02-20 14:00",
    createdAt: "2023-10-05",
  },
];

const AdminManagement: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", role: "admin", password: "" });

  const columns: Column<Admin>[] = [
    { key: "name", title: "이름", width: "100px" },
    { key: "email", title: "이메일" },
    {
      key: "role",
      title: "권한",
      width: "120px",
      render: (v) => <Badge variant={ROLE_BADGE[v]}>{ROLE_LABEL[v]}</Badge>,
    },
    {
      key: "status",
      title: "상태",
      width: "80px",
      render: (v) => <Badge variant={v === "active" ? "active" : "draft"}>{v === "active" ? "활성" : "비활성"}</Badge>,
    },
    { key: "lastLogin", title: "마지막 로그인", width: "160px" },
    { key: "createdAt", title: "생성일", width: "110px" },
    {
      key: "actions",
      title: "관리",
      width: "100px",
      render: (_, row) =>
        row.role !== "super_admin" ? (
          <div style={{ display: "flex", gap: 6 }} onClick={(e) => e.stopPropagation()}>
            <Button size="sm" variant="danger">
              비활성
            </Button>
          </div>
        ) : null,
    },
  ];

  return (
    <div className="admin-page">
      <ContentHeader
        title="관리자 계정 관리"
        description="어드민 계정을 생성하고 권한을 관리합니다."
        actions={[
          <Button key="add" variant="primary" onClick={() => setShowModal(true)}>
            + 관리자 추가
          </Button>,
        ]}
      />

      <div className="admin-page__card">
        <Table columns={columns} data={MOCK} rowKey="id" />
      </div>

      <Modal
        open={showModal}
        title="관리자 추가"
        onClose={() => setShowModal(false)}
        width="440px"
        footer={
          <>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              취소
            </Button>
            <Button variant="primary" onClick={() => setShowModal(false)}>
              추가
            </Button>
          </>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Input label="이름" placeholder="이름 입력" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
          <Input label="이메일" type="email" placeholder="이메일 주소 입력" value={form.email} onChange={(e) => setForm((p) => ({ ...p, email: e.target.value }))} />
          <Select
            label="권한"
            value={form.role}
            onChange={(e) => setForm((p) => ({ ...p, role: e.target.value }))}
            options={[
              { value: "admin", label: "어드민" },
              { value: "cs", label: "CS 담당" },
            ]}
          />
          <Input label="임시 비밀번호" type="password" placeholder="임시 비밀번호 입력" value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} />
        </div>
      </Modal>
    </div>
  );
};

export default AdminManagement;
